import React from "react";
import { Box } from "@chakra-ui/react";
import { Section } from "components/section";
import { DecorativeBackgroundImage, FillImage } from "components/images";
import { MediaAccordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import firstAccordionImage from "../../../../public/assets/platform/campaign-intelligence/accordion-1.png";
import secondAccordionImage from "../../../../public/assets/platform/campaign-intelligence/accordion-2.png";
import thisAccordionImage from "../../../../public/assets/platform/campaign-intelligence/accordion-3.png";
import { SyncFunnelsAnimation } from "./animations";

export function CampaignIntelligenceAccordion() {
  return (
    <Section>
      <TextTitle
        align="center"
        size="lg"
        maxW="600px"
        chip={{ text: "Warehouse-native campaign intelligence" }}
        title="Make better decisions with all of your data"
      />

      <MediaAccordion
        prerenderMedia={false}
        mt={{ base: "big", md: "huge" }}
        direction="right"
        variant="dynamic"
        items={[
          {
            title: "Discover customer behaviors and take action",
            content:
              "Explore customer data to find new opportunities. Put insights to work by creating and syncing audiences to your tools.",
            media: (
              <Box boxSize="100%" pos="relative">
                <DecorativeBackgroundImage src={firstAccordionImage} />
                <SyncFunnelsAnimation pos="absolute" top="30%" left="30%" />
              </Box>
            ),
          },
          {
            title: "Optimize campaigns across channels",
            content:
              "Compare campaigns apples-to-apples. Explore data across your business, including spend, engagement, and conversions.",
            media: (
              <FillImage
                priority
                src={secondAccordionImage}
                alt="Hightouch UI interface showing a table with three columns titled Campaign / Ad Set, Spend, and ROAS. The table has three rows representing three campaigns, all indicating increases in spend and ROAS."
              />
            ),
          },
          {
            title: "Run A/B experiments and incrementality tests",
            content:
              "Measure results across audience cohorts, no matter what channels you test or where your customers convert.",
            media: (
              <FillImage
                priority
                src={thisAccordionImage}
                alt="Hightouch UI interface showing a table with three columns titled Metric, Holdout group, and Treatment 1. The table has three rows, titled Revenue per user, Number of orders per user, and Average order value per user. The table shows significant increase for each row under Treatment 1."
              />
            ),
          },
        ]}
      />
    </Section>
  );
}
